<template>
<section>    
    <div class="wrap">
        <div class="find_showroom_info">
            <dl class="showroom_info">
                <dt>
                    {{ dealerItem.name }}
                    <div><img :src="dealerItem.brand.attUrl"></div>
                </dt>
                <dd>
                    <span>{{ dealerItem.nameEn }}</span>
                </dd>
            </dl>
        </div>

        <div class="showroom_consultant_list_box">
            <div class="title_box">
                <h4 class="title">전시장<span>{{totalCount}}</span></h4>
            </div>

            <ul class="showroom_consultant">
                <li v-for="(shop, idx) in shopItems" :key="`dealer-info-shop-list-${idx}`">
                    <a @click="$router.push(`/shopInfo/${shop.id}`)">
                        <figure>
                            <img :src="shop.attUrl ? shop.attUrl : resource.imgSampleShop">
                        </figure>
                        <figcaption>
                            <div class="name">
                                <dl>
                                    <dt>{{ shop.name }}</dt>
                                    <dd>소속 컨설턴트 {{ (shop.scCount) ? shop.scCount : 0 }}명</dd>
                                </dl>
                            </div>
                            <div class="social">
                                <span><img :src="resource.imgIconGood">{{ shop.good }}</span>
                                <span><img :src="resource.imgIconMessage">{{ shop.reviewCount }}</span>
                            </div>
                        </figcaption>
                    </a>
                </li>
            </ul>
        </div>
        
    </div>
</section>
</template>

<script>
import { mapState } from 'vuex';
import { InfinityScrollMixin } from '../../mixins/InfinityScrollMixin';

export default {
    name:'DealerShop',
    mixins: [ InfinityScrollMixin ],
    async created() {
        await this.$store.dispatch('GET_DEALER', this.dealerId)
        this.setScroll();
        this.getContentList();
        this.$store.commit('SHOW_ONLOAD');
    },
    destroyed() {
        this.removeScroll();
    },
    data() {
        return {
        }
    },
    computed: {
        ...mapState(["resource"]),
        ...mapState({
            dealerItem: state => state.dealer.item,
            shopItems: state => state.shop.items,
            totalCount: state => state.shop.totalCount,
        }),
        dealerId(){
            return this.$route.params.dealerId;
        },
    },
    methods: {
        getContentList() {
            if(this.shopItems.length < this.totalCount || this.page == 0) {
                this.$store.dispatch(
                    'GET_SHOP_LIST_PAGE',
                    {
                        dealerId: this.dealerId,
                        page: this.page++,
                        size: this.limit
                    }
                )
                .then(() => {
                    this.scrollPause = false;
                });
            }
            else {
                this.doneFlag = true;
            }
        },
    },
}
</script>

<style scoped>

</style>